import axios from 'axios';
import {backendHost} from '../../../../store/config';

const getListOrganization = (params) => {
    return axios.get(`${backendHost}/api/admin/object/list`, {params});
};

export {
    getListOrganization
}